const clearNode = (node) => {
  delete node.meta;
}

const clearCells = (cells) => {
  cells.forEach((cell) => {
    const { items } = cell;
    clearNode(cell);
    if (items && items.length > 0)
      clearItems(items);
  });
};

const clearItems = (items) => {
  items.forEach((item) => {
    const { rows } = item;
    clearNode(item);
    if (rows && rows.length > 0) {
      rows.forEach(row => {
        if (row.columns && row.columns.length > 0) {
          clearCells(row.columns);
        }
      });
    }
  });
};

const clearColumns = (columns) => {
  columns.forEach((column) => {
    const { items } = column;
    clearNode(column)
    if (items && items.length > 0)
      clearItems(items);
  });
};

export default (sections) => {
  sections.forEach((section) => {
    const { contents } = section;
    clearNode(section)
    if (contents && contents.length > 0)
      clearColumns(contents);
  });
  return sections;
};
